namespace SolovisGateway.Admin.Users {

    export class UserChangePasswordControl extends Solovis.UI.BaseControl {

        private _userId;
        private _isDirty;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        private _policyDescription;

        constructor(options) {
            super(options);

            this._userId = options.userId ? options.userId : null;

            this._isDirty = false;
        }

        public async doInitAsync(): Promise<void> {
            let response = await Solovis.Rpc.invoke("~/Admin/UserAdmin/GetUserPasswordPolicy", { userId: this._userId });

            this._policyDescription = response.result.policyDescription;
        }

        public doRender() {
            var self = this;

            var formDiv = $("<div>").appendTo(this.container);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            // New Password
            formBuilder.addEntry({
                name: "newPassword",
                label: "New Password",

                initialValue: "",

                help: {
                    text: this._policyDescription
                },

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "password",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Confirm Password
            formBuilder.addEntry({
                name: "confirmPassword",
                label: "Confirm Password",

                initialValue: "",

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "password",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        validate: function () {
                            var result = {
                                isValid: true,
                                message: null
                            };

                            var confirmPasswordInputControl = this;
                            var confirmPassword = confirmPasswordInputControl.value();
                            var newPassword = self._formBuilder.getValueByName("newPassword");

                            if (confirmPassword !== newPassword) {
                                result.isValid = false;
                                result.message = "Passwords do not match.";
                            }

                            return result;
                        }
                    });

                    return editorControl;
                }
            });

            formBuilder.setupDone();

            $(formBuilder).bind("valueChanged", function () {
                self._isDirty = true;
            });

            this._formBuilder = formBuilder;
        }

        public _getUserPasswordModel() {
            var newPassword = this._formBuilder.getValueByName("newPassword");
            var confirmPassword = this._formBuilder.getValueByName("confirmPassword");

            var model = {
                newPassword: newPassword,
                confirmPassword: confirmPassword,
                id: this._userId

            };

            return model;
        }

        public isDirty() {
            return this._isDirty;
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }
    }
   
}